/**
 * A MIME type consists of two parts, a type and a subtype, separated by a forward slash.
 * The type specifies the general media type as application, audio, image, message, model, multipart, text, or video.
 * The subtype, identifies the format for the media and varies across media types. For example, text/html corresponds to text in HTML format.
 *
 * Could be extended with the following values: https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types.
 */
export enum MimeContentType {
  Alternative = 'multipart/alternative',
  Binary = 'application/octet-stream',
  Docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  FhirJson = 'application/fhir+json',
  FhirXml = 'application/fhir+xml',
  Gif = 'image/gif',
  Hl7V3 = 'application/hl7-v3',
  Html = 'text/html',
  Jpg = 'image/jpeg',
  Json = 'application/json',
  Mixed = 'multipart/mixed',
  Mp4 = 'video/mp4',
  Pdf = 'application/pdf',
  Pkcs7 = 'application/pkcs7-mime',
  Png = 'image/png',
  Text = 'text/plain',
  Tiff = 'image/tiff',
  Word = 'application/msword',
  Xml = 'application/xml',
  Rtf = 'application/rtf',
  Odt = 'application/vnd.oasis.opendocument.text',
  Zip = 'application/zip',
}
